import gql from 'graphql-tag';

import type {
  GetSocialMediaCategoriesWithImagesQuery,
  UserCustomization,
  UserSocialMediaInput
} from 'types/graphql-api.generated';

import requestGraph from 'common/api/GraphApi/requestGraph';

const GET_CATEGORIES_WITH_IMAGES = gql`
  query GetSocialMediaCategoriesWithImages(
    $type: SocialMedia!
    $imagesFirst: Int!
  ) {
    socialMediaCategoryList(type: $type) {
      totalCount
      edges {
        cursor
        node {
          id
          internalId
          name
          tag
          sponsored
          rank
          images(first: $imagesFirst) {
            totalCount
            edges {
              node {
                id
                internalId
                path
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

const SET_USER_SOCIAL_CUSTOMIZATION = gql`
  mutation SetUserSocialCustomization($input: UserSocialMediaInput!) {
    setUserSocialCustomization(input: $input) {
      id
      customization {
        mainAvatar {
          internalId
          categoryId
          path
        }
        mainBanner {
          internalId
          categoryId
          path
        }
      }
    }
  }
`;

const GET_ME_CUSTOMIZATION = gql`
  query GetMeCustomization {
    me {
      user {
        customization {
          mainAvatar {
            internalId
            categoryId
            path
          }
          mainBanner {
            path
            internalId
            categoryId
          }
        }
      }
    }
  }
`;

export type GetCategoriesWithImagesResponse = {
  data?: GetSocialMediaCategoriesWithImagesQuery;
};

export async function getSocialMediaCategoriesWithImages(
  type: 'AVATAR' | 'BANNER',
  imagesFirst = 100
): Promise<GetCategoriesWithImagesResponse> {
  return requestGraph<GetCategoriesWithImagesResponse>({
    query: GET_CATEGORIES_WITH_IMAGES,
    variables: {
      type,
      imagesFirst
    }
  });
}

export async function setUserSocialCustomization(
  input: UserSocialMediaInput
): Promise<{
  data?: {
    setUserSocialCustomization?: { customization?: UserCustomization | null };
  };
}> {
  return requestGraph({
    query: SET_USER_SOCIAL_CUSTOMIZATION,
    variables: { input }
  });
}

export async function getMeCustomization(): Promise<{
  data?: {
    me?: { user?: { customization?: UserCustomization | null } };
  };
}> {
  return requestGraph({
    query: GET_ME_CUSTOMIZATION
  });
}
